<ng-container *ngIf="{ state: articleRevenueState$ | async, sharedDataState: sharedDataState$ | async } as s">
    <h1 mat-dialog-title class="active">
        {{ "app.dialog.article-revenue.title.header" | translate: { article: article.name } }}
    </h1>
    <div mat-dialog-content>
        <mat-progress-bar color="accent" [style.visibility]="s.state.isLoading ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>
        <div class="dialogHeader">
            <mat-generic-input (inputFormGroupChange)="onFormGroupChange($event)" [fields]="layout.filterFields"></mat-generic-input>
            <button
                mat-mini-fab
                color="primary"
                matTooltip="{{ 'app.dialog.article-revenue.actions.add.label' | translate }}"
                (click)="onOpenAddDialog()">
                <mat-icon>add</mat-icon>
            </button>
        </div>
        <div class="baseMeasureUnitInfo">
            <span>Basis-Maßeinheit:</span>
            <span>
                <ng-container *ngIf="article.baseMeasureUnitId !== null; else noMeasureUnit">
                    {{s.sharedDataState.measureUnitLookup[article.baseMeasureUnitId]?.name}}
                </ng-container>
                <ng-template #noMeasureUnit>-</ng-template>
            </span>

        </div>
        <table mat-table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="validFrom">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.article-revenue.validFrom.label" | translate }}</th>
                <td mat-cell *matCellDef="let revenue">{{ revenue.validFrom | date: 'dd.MM.yyyy' }}</td>
            </ng-container>

            <ng-container matColumnDef="validTo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.article-revenue.validTo.label" | translate }}</th>
                <td mat-cell *matCellDef="let revenue">{{ revenue.validTo | date: 'dd.MM.yyyy' }}</td>
            </ng-container>

            <ng-container matColumnDef="costAccountingType">
                <th mat-header-cell *matHeaderCellDef>{{ "app.model.article-revenue.costAccountingType.label" | translate }}</th>
                <td mat-cell *matCellDef="let revenue">{{ s.sharedDataState.costAccountingTypeLookup[revenue.costAccountingTypeId]?.name }}</td>
            </ng-container>

            <ng-container matColumnDef="revenueCt">
                <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before">{{ "app.model.article-revenue.revenue.label" | translate }}</th>
                <td mat-cell *matCellDef="let revenue">{{ revenue.revenueCt / 100 | currency:'EUR':'symbol':'1.2-2' }}</td>
            </ng-container>

            <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let revenue">
                    <button
                        color="warn"
                        mat-icon-button
                        (click)="onDeleteRevenue(revenue)"
                        matTooltip="{{ 'app.dialog.article-revenue.actions.delete.label' | translate }}">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="layout.columns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: layout.columns;"></tr>
        </table>
    </div>
</ng-container>
